import { render, staticRenderFns } from "./widgetBlack.vue?vue&type=template&id=438d4ae5&scoped=true&"
import script from "./widgetBlack.vue?vue&type=script&lang=js&"
export * from "./widgetBlack.vue?vue&type=script&lang=js&"
import style0 from "./widgetBlack.vue?vue&type=style&index=0&id=438d4ae5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "438d4ae5",
  null
  
)

export default component.exports